module.exports = __webpack_public_path__ + "static/media/movieType-action.c41b3413.jpg";